module.exports = __webpack_public_path__ + "static/media/JohnColtrane.8c3be28d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/Center/Block/img/JohnColtrane.jpeg
// module id = 607
// module chunks = 0